import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ridango-ui-back-button',
    templateUrl: './back-button.component.html',
    styleUrls: ['./back-button.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BackButtonComponent {
    @Input() showArrow = true;
    @Input() bottomMargin = true;
    @Input() classIcon = '';
    @Output() onBack = new EventEmitter<any>();

    back() {
        this.onBack.emit();
    }
}
